import {
  createFeatureSelector,
  createSelector,
  MemoizedSelector,
} from "@ngrx/store";
import {
  PIPELINE_GENERIC_FEATURE_KEY,
  PIPELINE_GENERIC_PIPELINE_SECTION_FEATURE_KEY,
  PIPELINE_GENERIC_ACCOUNTABLE_FUNCTION_LINK_FEATURE_KEY,
  PIPELINE_GENERIC_PIPELINE_ASSET_LINK_FEATURE_KEY,
  PIPELINE_GENERIC_LAND_TITLE_FEATURE_KEY,
  PIPELINE_GENERIC_IMPACTED_ASSET_FEATURE_KEY,
  GenericState,
  GenericPartialState,
  GenericAdapter,
  UploadStatus,
} from "./pipeline-generic.reducer";

// Lookup the 'Pipeline' feature state managed by NgRx
export const getGenericState = createFeatureSelector<
  GenericPartialState,
  GenericState
>(PIPELINE_GENERIC_FEATURE_KEY);

export const getGenericStatePipelineSection = createFeatureSelector<
  GenericPartialState,
  GenericState
>(PIPELINE_GENERIC_PIPELINE_SECTION_FEATURE_KEY);

export const getGenericStateAccountableFunction = createFeatureSelector<
  GenericPartialState,
  GenericState
>(PIPELINE_GENERIC_ACCOUNTABLE_FUNCTION_LINK_FEATURE_KEY);

export const getGenericStatePipelineAsset = createFeatureSelector<
  GenericPartialState,
  GenericState
>(PIPELINE_GENERIC_PIPELINE_ASSET_LINK_FEATURE_KEY);

export const getGenericStateLandTitle = createFeatureSelector<
  GenericPartialState,
  GenericState
>(PIPELINE_GENERIC_LAND_TITLE_FEATURE_KEY);

export const getGenericStateImpactedAsset = createFeatureSelector<
  GenericPartialState,
  GenericState
>(PIPELINE_GENERIC_IMPACTED_ASSET_FEATURE_KEY);

const { selectAll, selectEntities } = GenericAdapter.getSelectors();

export function switchStateSlice(type): any {
  if (type === "PipelineSection") {
    // console.log("Type Passed in Selector Function", type);
    return getGenericStatePipelineSection;
  }

  if (type === "AccountableFunctionLink2") {
    // console.log("Type Passed in Selector Function", type);
    return getGenericStateAccountableFunction;
  }

  if (type === "PipelineAssetLink2") {
    // console.log("Type Passed in Selector Function", type);
    return getGenericStatePipelineAsset;
  }

  if (type === "LandTitle") {
    // console.log("Type Passed in Selector Function", type);
    return getGenericStateLandTitle;
  }

  if (type === "ImpactedAsset") {
    // console.log("Type Passed in Selector Function", type);
    return getGenericStateImpactedAsset;
  }
}

export const getAllGeneric = (type) => {
  console.log("Type Passed in Selector 2", type);

  return createSelector(
    switchStateSlice(type),
    (state: GenericState) => selectAll(state),
  );
};

export const loadingGeneric = (type) => {
 return createSelector(
  switchStateSlice(type),
  (state: GenericState) => state.loaded,
);
}

export const getGenericError = createSelector(
  getGenericState,
  (state: GenericState) => state.error,
);

export const getGenericEntities = createSelector(
  getGenericState,
  (state: GenericState) => selectEntities(state),
);

export const getSelectedId = createSelector(
  getGenericState,
  (state: GenericState) => state.selectedId,
);

export const getSelected = createSelector(
  getGenericEntities,
  getSelectedId,
  (entities, selectedId) => selectedId && entities[selectedId],
);

const getError = (state: GenericState): string => state.error;

const getStarted = (state: GenericState): boolean =>
  state.status === UploadStatus.Started;

const getRequested = (state: GenericState): boolean =>
  state.status === UploadStatus.Requested;

const getReady = (state: GenericState): boolean =>
  state.status === UploadStatus.Ready;

const getProgress = (state: GenericState): number => state.progress;

const getInProgress = (state: GenericState): boolean =>
  state.status === UploadStatus.Started && state.progress >= 0;

const getFailed = (state: GenericState): boolean =>
  state.status === UploadStatus.Failed;

const getCompleted = (state: GenericState): boolean =>
  state.status === UploadStatus.Completed;

export const selectUploadFileError: MemoizedSelector<
  object,
  string
> = createSelector(
  getGenericState,
  getError,
);

export const selectUploadFileReady: MemoizedSelector<
  object,
  boolean
> = createSelector(
  getGenericState,
  getReady,
);

export const selectUploadFileRequested: MemoizedSelector<
  object,
  boolean
> = createSelector(
  getGenericState,
  getRequested,
);

export const selectUploadFileStarted: MemoizedSelector<
  object,
  boolean
> = createSelector(
  getGenericState,
  getStarted,
);

export const selectUploadFileProgress: MemoizedSelector<
  object,
  number
> = createSelector(
  getGenericState,
  getProgress,
);

export const selectUploadFileInProgress: MemoizedSelector<
  object,
  boolean
> = createSelector(
  getGenericState,
  getInProgress,
);

export const selectUploadFileFailed: MemoizedSelector<
  object,
  boolean
> = createSelector(
  getGenericState,
  getFailed,
);

export const selectUploadFileCompleted: MemoizedSelector<
  object,
  boolean
> = createSelector(
  getGenericState,
  getCompleted,
);
